<template>
<div class="page_transport">
  <div class="container py-5">
    <div class="page_topic_blcok my-4">
      <div class="topic_border">
        <p class="topic_eng">COMPANY_INFO</p>
        <p class="topic_cht">修改公司資訊</p>
      </div>
    </div>
    <!-- 修改公司資訊 -->
    <div class="member_block">
      <!--<h2>
        <img src="@/assets/icons/member_title.png" /> 修改公司資訊
      </h2>-->
    </div>
    <div class="member_join_block">
      <!-- 表單開始 -->
      <form class="member_join_box">
        <div>
          <label>公司統編</label>
          <p style="font-size:15px;">01234567</p>
        </div>
        <div>
          <label>公司/機關名稱</label>
          <p style="font-size:15px;">上聯國際展覽</p>
        </div>
        <div>
          <label>負  責  人</label>
          <p>
            <span class="sub_label">姓　　名</span>
            <input type="text" class="member_input member_input_md">
            <br>
            <span class="sub_label">職　　稱</span>
            <input type="text" style="margin-top:10px;" class="member_input member_input_md">
          </p>
        </div>
        <div>
          <label><span class="require_mark">*</span> 公司地址</label>
          <p>
            <input type="text" class="member_input member_input_xs">
            <select class="member_input member_input_sm select">
              <option value="0">請選擇</option>
              <option value="0">台北市</option>
              <option value="0">新北市</option>
              <option value="0">新竹市</option>
              <option value="0">台中市</option>
              <option value="0">高雄市</option>
            </select>
            <select class="member_input member_input_sm select">
              <option value="0">請選擇</option>
              <option value="0">信義區</option>
              <option value="0">大安區</option>
              <option value="0">松山區</option>
              <option value="0">中正區</option>
            </select>
            <br>
            <input type="text" style="margin-top:10px;" class="member_input member_input_md">
          </p>
        </div>
        <div>
          <label><span class="require_mark" style="visibility:hidden;">* </span>連 絡 人</label>
          <div class="member_contract" style="padding-left:40px;">
            <p>
              <label class="sub_label"><span class="require_mark">*</span> 姓　　名</label>
              <input type="text" class="member_input member_input_md">
            </p>
            <p>
              <label class="sub_label"><span class="require_mark">*</span> 職　　稱</label>
              <input type="text" class="member_input member_input_md">
            </p>
            <p>
              <label class="sub_label"><span class="require_mark">*</span> 公司電話</label>
              <input type="text" class="member_input member_input_md">
              <br>
              <span style="font-size:14px;">（如有分機請以 #分機號碼 表示）</span>
            </p>
            <p>
              <label class="sub_label"><span class="require_mark">*</span> 手機號碼</label>
              <input type="text" class="member_input member_input_md">
              <br>
              <span style="font-size:14px;">（填寫範例：0912345678）</span>
            </p>
            <p>
              <label class="sub_label"><span class="require_mark" style="visibility:hidden;">*</span> 傳真號碼</label>
              <input type="text" class="member_input member_input_md">
            </p>
            <p>
              <label class="sub_label"><span class="require_mark">*</span> E-mail</label>
              <input type="email" class="member_input member_input_md">
            </p>
          </div>
        </div>
        <!-- 按鈕 -->
        <button class="submit_btn red" style="margin:20px auto;display:block;">確 認 送 出</button>
      </form>
    </div>
    <!-- 修改密碼 -->
    <div class="page_topic_blcok my-4">
      <div class="topic_border">
        <p class="topic_eng">PASSWORD_RESET</p>
        <p class="topic_cht">修改密碼</p>
      </div>
    </div>
    <div class="member_block">
      <!--<h2>
        <img src="@/assets/icons/member_title.png" /> 修改密碼
      </h2>-->
    </div>
    <div class="member_join_block">
      <!-- 表單開始 -->
      <form class="member_join_box">
        <div>
          <label><span class="require_mark">*</span> 原密碼</label>
          <p>
            <input type="text" class="member_input member_input_md">
          </p>
        </div>
        <div>
          <label><span class="require_mark">*</span> 新密碼</label>
          <p>
            <input type="text" class="member_input member_input_md">
          </p>
        </div>
        <div>
          <label><span class="require_mark">*</span> 確認密碼</label>
          <p>
            <input type="text" class="member_input member_input_md">
          </p>
        </div>
        <!-- 按鈕 -->
        <button class="submit_btn red" style="margin:auto;display:block;">確 認 送 出</button>
      </form>
    </div>
  </div>  
</div>



</template>

<script>
export default {
  data () {
    return{};
  }
}
</script>

<style>
.member_block>h2 {
  border-bottom:3px solid rgb(10, 116, 0);
  padding:4px 0;
}
.member_join_box {
  max-width:600px;
  margin:25px auto 0;
}
.member_join_box>div {
  display:flex;
  justify-content:flex-start;
  align-items:baseline;
  flex-wrap:wrap;
}
.member_join_box>div>label {
  width:140px;
  text-align:right;
}

@media (max-width:550px){
  .member_join_box>div>label {
    width:100%;
    text-align:left;
  }
}

.member_join_box>div>p {
  padding-left:15px;
}

.member_input {
  height:35px;
  margin:0 3px;
  font-size:15px;
}
.member_input.member_input_xs {
  width:60px;
}
.member_input.member_input_sm {
  width:130px;
}
.member_input.member_input_md {
  width:200px;
}
.member_input.member_input_lg {
  width:400px;
}


.sub_label {
  width:71px;
  font-size:15px;
}

.member_join_box div>label {
  font-weight:bold;
}
.require_mark {
  color:red;
}

.member_contract>p {
  margin:0 0 8px;
}


/**page_topic**/
.page_topic_blcok { 
  display:inline-block; 
  text-align: right;
}
.page_topic_blcok .topic_border { 
  padding: 0px 1rem 1px 0;
  border-right:1px solid #d6d6d6; 
  font-size:2rem; 
  line-height:1.1;
}
.page_topic_blcok .topic_border .topic_eng { 
  color:#8c8c8d;
  line-height:1.5;
  margin:0;
}
.page_topic_blcok .topic_border .topic_cht { 
  color:#b0b0b0;
  line-height:1.5;
  letter-spacing:9px;
  margin-right:-9px; 
}

/* btn */
.submit_btn{
  outline:none;
  border:0;
  margin:0;
  padding:0;
  box-sizing: border-box;
}
.submit_btn.red{
  background: rgba(255, 0, 51, 1);
  color:white;
  width:140px;
  height:40px;
  border:1px solid rgba(255, 255, 255, 1);
  border-radius: 5px;
  box-shadow: 5px 5px 5px rgba(0, 0, 0, 0.35);
}
.submit_btn.blue{
  background: rgba(25, 158, 216, 1);
  color:white;
  width:140px;
  height:40px;
  border:1px solid rgba(255, 255, 255, 1);
  border-radius: 5px;
  box-shadow: 5px 5px 5px rgba(0, 0, 0, 0.35);
}
</style>



// WEBPACK FOOTER //
// src/components/pages/member_modify.vue